<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置参数"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
      <FormItem prop="driverName" label="密码">
        <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
        <Button type="primary" @click="posswordTwo">密码2</Button>
        <Input v-model="setDriverCardParams.possword" type="password" password placeholder="请输入密码">
        </Input>
      </FormItem>
      <FormItem>
        <label>注：如不修改的字段请留空</label>
      </FormItem>
      <FormItem prop="driverName" label="驾驶员名">
        <Input v-model="setDriverCardParams.driverName" placeholder="请输入驾驶员名">
        </Input>
      </FormItem>
      <FormItem prop="driverCardNum" label="驾驶员身份证">
        <Input v-model="setDriverCardParams.idCardNum" placeholder="请输入驾驶员身份证">
        </Input>
      </FormItem>
<!--            <FormItem prop="driverLicenseNum" label="从业资格证号">-->
            <FormItem prop="driverLicenseNum" label="从业资格证号">
              <Input v-model="setDriverCardParams.driverLicenseNum" placeholder="请输入从业资格证号">
              </Input>
            </FormItem>
            <FormItem prop="driverLicenseNum" label="发证机构名称">
              <Input v-model="setDriverCardParams.organizationNames" placeholder="请输入发证机构名称">
              </Input>
            </FormItem>
            <FormItem prop="driverLicenseNum" label="证件有效期">
              <Input v-model="setDriverCardParams.indate" placeholder="请输入证件有效期">
              </Input>
            </FormItem>
      <FormItem prop="registrationNum" label="车牌号">
        <Input v-model="setDriverCardParams.registrationNum" placeholder="请输入车牌号">
        </Input>
      </FormItem>
      <FormItem prop="vin" label="车架号">
        <Input v-model="setDriverCardParams.vin" placeholder="请输入车架号">
        </Input>
      </FormItem>
      <FormItem prop="vehicleType" label="车辆类型">
<!--        <Input v-model="setDriverCardParams.vehicleType" placeholder="请输入车辆类型">-->
<!--        </Input>-->
        <Select placeholder="车辆类型"
                v-model="setDriverCardParams.vehicleType">
          <Option v-for="(option, index) in vehicleTypeOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem v-if="setDriverCardParams.vehicleType == 0" prop="vehicleType" label="自定义车辆类型">
        <Input v-model="setDriverCardParams.customized" placeholder="请输入自定义车辆类型">
        </Input>
      </FormItem>
      <FormItem prop="vin" label="发动机号">
        <Input v-model="setDriverCardParams.engineNum" placeholder="请输入发动机号">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'rmsetdriverparametersmodal',
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        possword: 'admin',
        driverName: '',
        idCardNum: '',
        driverLicenseNum: '',
        organizationNames: '',
        indate: '',
        registrationNum: '',
        vin: '',
        vehicleType: '',
        customized: '',
        engineNum: '',
      },
      vehicleTypeOptions:[
        {label:'自定义', value: '0'},
        {label:'出租车', value: '1'},
        {label:'校车', value: '2'},
        {label:'小型客车', value: '3'},
        {label:'中型客车', value: '4'},
        {label:'大型客车', value: '5'},
        {label:'小型货车', value: '6'},
        {label:'中型货车', value: '7'},
        {label:'大型货车', value: '8'},
        {label:'小型挂车', value: '9'},
        {label:'中型挂车', value: '10'},
        {label:'大型挂车', value: '11'},
        {label:'危险品运输车', value: '12'},
        {label:'未知车辆', value: '13'},
      ],

    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.driverName = ''
        this.setDriverCardParams.idCardNum = ''
        this.setDriverCardParams.indate = ''
        this.setDriverCardParams.organizationNames = ''
        this.setDriverCardParams.driverLicenseNum = ''
        this.setDriverCardParams.registrationNum = ''
        this.setDriverCardParams.vin = ''
        this.setDriverCardParams.vehicleType = ''
        this.setDriverCardParams.customized = ''
        this.setDriverCardParams.engineNum = ''
        this.possworsOne()
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.driverName = ''
      this.setDriverCardParams.idCardNum = ''
      this.setDriverCardParams.indate = ''
      this.setDriverCardParams.organizationNames = ''
      this.setDriverCardParams.driverLicenseNum = ''
      this.setDriverCardParams.registrationNum = ''
      this.setDriverCardParams.vin = ''
      this.setDriverCardParams.vehicleType = ''
      this.setDriverCardParams.customized = ''
      this.setDriverCardParams.engineNum = ''
    },
    onSendDriverCardParams () {

      console.log('99admin,' + this.setDriverCardParams.possword + ',SXCA'
        + this.setDriverCardParams.driverName + ','
        + this.setDriverCardParams.idCardNum + ','
        + this.setDriverCardParams.indate + ','
        + this.setDriverCardParams.organizationNames + ','
        + this.setDriverCardParams.driverLicenseNum + ','
        + this.setDriverCardParams.registrationNum + ','
        + this.setDriverCardParams.vin + ','
        + this.setDriverCardParams.vehicleType + ','
        + this.setDriverCardParams.customized + ','
        + this.setDriverCardParams.engineNum + '!')
      let content = '99admin,' + this.setDriverCardParams.possword + ',SXCA'
        + this.setDriverCardParams.driverName + ','
        + this.setDriverCardParams.idCardNum + ','
        + this.setDriverCardParams.indate + ','
        + this.setDriverCardParams.organizationNames + ','
        + this.setDriverCardParams.driverLicenseNum + ','
        + this.setDriverCardParams.registrationNum + ','
        + this.setDriverCardParams.vin + ','
        + this.setDriverCardParams.vehicleType + ','
        + this.setDriverCardParams.customized + ','
        + this.setDriverCardParams.engineNum + '!'
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content:content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    possworsOne(){
      this.setDriverCardParams.possword = 'admin'
    },
    posswordTwo(){
      this.setDriverCardParams.possword = 'JC336699'
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
